import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loadingFlag:0,
    contactList: [],
    locationDropdownList: {},
    errorMessage: null,
    successMessage: null,
    count: 0,
    filteredList: {},
    loader: true,
}

export const contactSlice = createSlice({
    name: 'contacts', initialState,
    reducers: {
        setInitalState: (state, action) => {
            state.successMessage = null;
            state.errorMessage = null;
        },
        getContactListSuccess: (state, action) => {
            state.contactList = action.payload;
            state.errorMessage = null;
        },
        getcontactListError: (state, action) => {
            state.contactList = [];
            state.errorMessage = action.payload;
        },
        getLocationDropdownSuccess: (state, action) => {
            state.locationDropdownList = action.payload;
            state.errorMessage = null;
        },
        getLocationDropdownError: (state, action) => {
            state.locationDropdownList = {};
            state.errorMessage = action.payload;
        },
        deleteEmployerUserSuccess: (state, action) => {
            state.count = state.count + 1;
            state.successMessage = action.payload;
            state.errorMessage = null;
        },
        deleteEmployerUserError: (state, action) => {
            state.successMessage = null;
            state.errorMessage = action.payload;
        },
        setContactLoader: (state, action) => {
            state.loader = action.payload
        },
        setLoadingFlagIncrement:state => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        }
    }
});
export const {
    setInitalState,
    getContactListSuccess,
    getcontactListError,
    getLocationDropdownSuccess,
    getLocationDropdownError,
    deleteEmployerUserSuccess,
    deleteEmployerUserError,
    setContactLoader,
    setLoadingFlagIncrement,
    setLoadingFlagDecrement
} = contactSlice.actions;

export default contactSlice.reducer;
